import type { DailyUse } from "../lib/types";

interface Props {
  value: DailyUse | null;
  onChange: (v: DailyUse) => void;
}

const OPTIONS: Array<{ value: DailyUse; label: string }> = [
  { value: "yes", label: "Yes" },
  { value: "maybe", label: "Maybe" },
  { value: "no", label: "No" },
];

export function YesMaybeNo({ value, onChange }: Props) {
  return (
    <div role="radiogroup" aria-label="Daily use" className="grid grid-cols-3 gap-2">
      {OPTIONS.map((o) => {
        const active = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            // biome-ignore lint/a11y/useSemanticElements: custom-styled radiogroup; <input type="radio"> doesn't support the visual treatment
            role="radio"
            aria-checked={active}
            onClick={() => onChange(o.value)}
            className={`select-none rounded-xl border py-4 text-base font-semibold uppercase tracking-wider transition-colors active:scale-95 ${
              active
                ? "border-amber bg-amber text-charcoal"
                : "border-cream/15 bg-charcoal-2 text-cream hover:border-amber/40"
            }`}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
